<template>
  <div
    class="slot-card-wrapper"
    :id="id"
    :lastId="lastId"
    :class="getCardType === 'shadow' ? 'card-wrapper' : ''"
  >
    <div class="card" :class="`card-${getCardType}`">
      <div class="before-head" v-if="isBeforeHead">
        <slot name="before_head"></slot>
      </div>
      <div class="card-head" v-if="isCardHead">
        <slot name="card_head"></slot>
      </div>
      <div class="card-body" :class="{ 'b-btm-1' : isCardFooter }">
        <slot name="card_body"></slot>
      </div>
      <div class="card-footer" v-if="isCardFooter">
        <slot name="card_footer"></slot>
        <div class="menu-footer" v-if="isMenuFooter">
          <div class="clik" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
          <div class="dropdown-menu garis-listkomisi">
            <slot name="menu_footer"></slot>
          </div>
        </div>
      </div>
      <div class="menu-card" v-if="isMenuCard">
        <div class="clik" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></div>
        <div class="dropdown-menu garis-listkomisi">
          <slot name="menu_card"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SOSlotCard",
  props: {
    dropdownMenu: {
      type: String,
      default: "none", // footer | card,
    },
    cardType: {
      type: String,
      default: "box", // box | shadow | none,
    },
    id: {
      type: String,
      default: "",
    },
    lastId: {
      type: String,
      default: "",
    }
  },
  data() {
      return {
          observer: null,
					fetchedId: [],
      };
  },
  mounted() {
      this.observerCard();
  },
  computed: {
    isMenuCard() {
      return this.dropdownMenu === "card";
    },
    isMenuFooter() {
      return this.dropdownMenu === "footer";
    },
    isBeforeHead() {
      return !!this.$slots.before_head;
    },
    isCardHead() {
      return !!this.$slots.card_head;
    },
    isCardFooter() {
      return !!this.$slots.card_footer;
    },
    getCardType() {
      return this.cardType;
    },
  },
  methods: {
     observerCard() {
        const cards = document.querySelectorAll(".slot-card-wrapper");
        let { doLoadMore, lastId, toogleCard } = this;

        this.observer = new IntersectionObserver(
            function(entries, observer) {
                entries.forEach((entry) => {
                    /** Do Something when it enter the screen */
                    if (entry.isIntersecting) {
                        /** Check if last target enter the screen */
												const targetId = entry.target.id;
                        if (lastId === targetId) {
                            doLoadMore(targetId);
                        }

                        toogleCard({
                            mode: "add",
                            data: { id: entry.target.id, yDir: entry.target.offsetTop },
                        });
                    }
                    /** Do Something when it leave the screen */
                    if (!entry.isIntersecting) {
                        toogleCard({
                            mode: "remove",
                            data: { id: entry.target.id, yDir: entry.target.offsetTop },
                        });
                    }
                });
            },
            { root: null, threshold: 1 }
        );
        cards.forEach((card) => {
            this.observer.observe(card);
        });
    },
    /**
     * Pastikan Total All data lebih kecil dari total display item | data.total > pagination.length |
     * Dan Pastikan tidak sedang melakukan Request/Fetching api | isFetching === false |
     */
    doLoadMore(targetId) {
			if (this.fetchedId.includes(targetId)) {
				return
			}
			this.fetchedId.push(targetId)
      this.$emit("loadMore");
    },
    /**
     * Gunakan untuk menyimpan card yg tampil dalam screen
     */
    toogleCard(data) {
        this.$emit("toogleCard", data);
    }
  }
};
</script>

<style scoped>
.card-wrapper {
  border-radius: 8px;
  box-shadow: 0px 8px 20px rgb(0 0 0 / 7%);
}

.card {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  background-color: white;
  padding: 10px 0px;
}

.card-shadow {
  box-shadow: 0px 8px 20px rgba(0, 34, 119, 0.06);
  border-radius: 5px;
  border: unset;
}

.card-box {
  border: 1px solid #c8d0dd;
  border-radius: 5px;
}

.card-none {
  border: unset;
}

.before-head,
.card-head,
.card-footer,
.card-body {
  padding: 0px 18px;
  letter-spacing: -0.02em;
}

.before-head {
  line-height: 150%;
  font-size: 12px;
  font-weight: normal;
}

.card-head {
  margin-bottom: 4px;
  color: black;
  font-size: 16px;
  font-weight: 600;
  line-height: 155%;
}

.card-body {
  line-height: 150%;
  color: #6f7287;
  font-size: 13px;
  font-weight: normal;
  padding-bottom: 0px;
}

.b-btm-1 {
  border-bottom: 1px solid #ededed;
  padding-bottom: 8px;
}

.card-footer {
  padding-top: 8px;
  background-color: unset;
  color: black;
  font-size: 14px;
  font-weight: 600;
}
</style>
